"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
class Service {
    constructor(props) {
        this.proxyServiceUrl = props.safetyValveCertificatesApi;
    }
    getInletSizes() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                axios_1.default
                    .get(`${this.proxyServiceUrl}/Criteria`, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                })
                    .then((response) => resolve(response.data.calibers));
            });
        });
    }
    findId(year, month, inletSize, serialNumber, setPressure) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                const url = `${this.proxyServiceUrl}/Certificate?year=${year}&month=${month}&` +
                    `caliber=${inletSize}&serialNo=${serialNumber}&setPressure=${setPressure}`;
                axios_1.default
                    .get(url, {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                })
                    .then(response => {
                    resolve(response.data);
                })
                    .catch(error => {
                    if (error.response.status === 404) {
                        resolve(null);
                    }
                });
            });
        });
    }
    buildUrl(id) {
        return `${this.proxyServiceUrl}/Certificate/${id}`;
    }
}
exports.Service = Service;
exports.default = Service;
